import { OpnOfferEvaluationMethodModel } from "src/common";

export class OpnElementViewModel {
	element: any;
	isValid: any;
	getElement: any;
	delete: any;
}
